import { useContext, useMemo, useState } from 'react';
import { useWatch } from 'react-hook-form';

import ContentFieldGroup from './components/contentFieldGroup/contentFieldGroup';
import ProhibitionBeautyFieldGroup from './components/prohibitionBeautyFieldGroup/prohibitionBeautyFieldGroup';
import ReelsGuidelineFieldGroup from './components/reelsGuidelineFieldGroup/reelsGuidelineFieldGroup';
import SubtitleFieldGroup from './components/subtitleFieldGroup/subtitleFieldGroup';
import TagFieldGroup from './components/tagFieldGroup/tagFieldGroup';
import CleanVideoFieldGroup from './components/cleanVideoFieldGroup/cleanVideoFieldGroup';
import CoAuthorFieldGroup from './components/coAuthorFieldGroup/coAuthorFieldGroup';
import CampaignFormStepButtons from '../../../../../campaignFormStepButtons/campaignFormStepButtons';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { CampaignFormStepTwoContext } from '../../campaignFormStepTwo.context';
import PartnershipAdvertisementCodeFieldGroup from './components/partnershipAdvertisementCodeFieldGroup/partnershipAdvertisementCodeFieldGroup';
import { BEAUTY_OUTPUT_GROUP_NAMES } from 'pages/campaigns/campaignForm/campaignForm.constants';

const BeautyCampaignFormStepTwo = () => {
  const {
    updateCampaignId,
    guidelineRuleFormMethods,
    setStep,
    storeOrUpdateTemporaryCampaignMutate,
    getParsedGuidelineRules,
    campaignFormMethods,
    showLoader,
    setShowLoader,
  } = useContext(CampaignFormContext);
  const { isFormValid, onSuccessStoreOrUpdateTemporaryCampaignCallback } = useContext(CampaignFormStepTwoContext);

  const [needCoAuthor, setNeedCoAuthor] = useState<boolean>(false);

  const guidelineFormValues = useWatch({
    control: guidelineRuleFormMethods.control,
    name: ['PREFERRED_VIDEO_TYPE', 'CO_AUTHOR', ...BEAUTY_OUTPUT_GROUP_NAMES],
  });

  const validatedNextButton = useMemo(() => {
    const [preferredVideoType, coAuthor, ...beautyOutputFields] = guidelineFormValues;
    if (
      !isFormValid ||
      // 필수 장면이 하나라도 선택이 안된 경우
      Object.values(beautyOutputFields).filter(Boolean)?.length <= 0 ||
      // 공동 작업자 추가가 필요함에 체크되어있고, 공동 작업자가 추가되어있지 않은 경우
      (needCoAuthor && (coAuthor?.value as string[])?.filter(Boolean)?.length <= 0) ||
      // 선호하는 유형이 선택되지 않은 경우
      !preferredVideoType ||
      preferredVideoType?.value == null
    ) {
      return false;
    } else {
      return true;
    }
  }, [isFormValid, guidelineFormValues, needCoAuthor]);

  const onClickNext = () => {
    if (!showLoader) {
      if (updateCampaignId) {
        setStep((prevStep) => prevStep + 1);
      } else {
        setShowLoader(true);

        const outputTypeFl = campaignFormMethods.getValues('outputTypeFl');
        const guidelineRules = getParsedGuidelineRules();

        storeOrUpdateTemporaryCampaignMutate({
          campaign: {
            outputTypeFl,
          },
          guidelineRules,
          options: {
            onSuccess: (response) => {
              onSuccessStoreOrUpdateTemporaryCampaignCallback(response);
            },
          },
        });
      }
    }
  };

  return (
    <>
      <div className="flex flex-col gap-[50px] mt-[100px]">
        {/* 1. 오늘룩 필수 가이드라인 */}
        <ProhibitionBeautyFieldGroup />
        {/* 2. 영상 가이드라인 설정 */}
        <ReelsGuidelineFieldGroup />
        {/* 3. 자막 내용 입력 */}
        <SubtitleFieldGroup />
        {/* 4. 포스팅 글 내용 입력 */}
        <ContentFieldGroup />
        {/* 5. 태그 설정 */}
        <TagFieldGroup />
        {/* 6. 클린본 요청 */}
        <CleanVideoFieldGroup />
        {/* 7. 공동 작업자 추가 */}
        <CoAuthorFieldGroup needCoAuthor={needCoAuthor} setNeedCoAuthor={setNeedCoAuthor} />
        {/* 8. 파트너십 광고 코드 발급 */}
        <PartnershipAdvertisementCodeFieldGroup />
      </div>

      <CampaignFormStepButtons disabledNextButton={!validatedNextButton} onClickNext={onClickNext} />
    </>
  );
};

export default BeautyCampaignFormStepTwo;
